import deviceService from "@/api/device";
// import sensorService from "@/api/sensorService";
import router from '@/router/index';
import { MESSAGES } from '@/utils/constants';
// import { resetSeconds } from "@/utils/date-helpers";
//  import FileSaver from 'file-saver'
import { notifyApiError, notify, notifyError } from '@/utils/notification-helper';
import FileSaver from 'file-saver';

const state = {
    devices: [],
    newDevice: {},
    loader: false,
    EmployeeErrors: [],
    initialData: {},
    pageSize:5,
    PageNo:1,
    searchQuery:" ",
    auditVals:[],
    totalCount:0,
    pageable: {
          previousNext: true,
          pageSizes: [5, 10, 25, 100, 500],
        },
    skip:0,
    take:5,

}
const getters = {
    getDevices: (state, getters, rootState, rootGetters) => rootGetters.getDevices ?  rootGetters.getDevices : [],
    getEditDevice: state => state.newDevice,
    getSensors: (state) => state.sensors,
    getDeviceType: (state, getters, rootState, rootGetters) => rootGetters.getDeviceTypes,
    getTenants: (state, getters, rootState, rootGetters) => rootGetters.getTenants,
};

const actions = {

    async getDevices({ commit,state }) {
        state.loader = true;
        // let id = rootState.selectedFacility ? rootState.selectedFacility.id : 0
        // const sensors

        let data={
            pageSize:state.pageSize,
            PageNo:state.PageNo,
            searchQuery:state.searchQuery,
        }
        const response = await deviceService.getDevices(data);
        state.loader=false
        commit('get', response)
    },
    async getAudit({ commit }, imei) {
        commit('getAudit',[]);

         return await deviceService.deviceAuditLog(imei)
        // const response = await deviceService.deviceAuditLog(imei);
        // console.log('##editDevice result received : ', response);
    },
    pageChange({dispatch},event) {
        state.skip = event.page.skip;
        state.take = event.page.take;
        // if (!rootState.selectedFacility) {
        //     return;
        // }
        state.PageNo = event.page.skip/event.page.take+1
        state.pageSize = event.page.take
        dispatch("getDevices")
    
      },
      searchReports({dispatch,state},data){
        state.searchQuery=data
        dispatch("getDevices")
      },
      clearData({dispatch,state}){
        state.pageSize=5,
        state.take=5,
        state.skip=0,
        state.totalCount=0,
        state.PageNo=1,
        state.searchQuery=""
        dispatch("getDevices")
      },
    async export({ commit },data) {
        await deviceService.exportTemplate(data).then(({ data }) => {
            FileSaver(data, 'Device' + '.xlsx')
        }).catch(notifyApiError);
        commit('exportedData');
    },
    async getInitialData({commit, state}) {
        state.loader=true
        const response = await deviceService.getInitialData();
        state.loader=false
        commit('getInitialData', response.data)
    },
    async getDevice({ commit,state, rootState }) {
        state.loader=true
        let id = rootState.selectedFacility ? rootState.selectedFacility.id : 0
        const response = await deviceService.getDevice(id);
        state.loader=false
        commit('get', response.data.result)     
    },
    async addDevice({ commit, rootState }, device) {
        let id = rootState.selectedFacility ? rootState.selectedFacility.id : 0
        device.facilityID = id;
        const response = await deviceService.addDevice(device);
        if (response.data.status) {
            commit('addDevice', response.data.result, { root: true });
        } 
        return response.data;
    },
    async editDevice({ commit }, device) {
        // const response = await deviceService.getDeviceById(device.id);
        // console.log('##editDevice result received : ', device);
        commit('edit', device);//response.data.result)
    },
    async updateDevice({ commit }, device) {
        const response = await deviceService.updateDevice(state.editId, device);
        commit('updateDevice', response.data.result, { root: true });
    },
    async deleteDevice({ commit }, device) {
        await deviceService.deleteDevice(device.dataItem.deviceId);
        commit('removeDevice', device.dataItem.deviceId);
    },
    async uploadTemplate({ commit }, event) {
        let data = new FormData();
        let file = event.target.files[0];
        // console.log("file", event.target.files[0])
        data.append('name', 'my-file')
        data.append('file', file)
        let config = {
            header: {
                'Content-Type': 'multipart/form-data',
            }
        }
        await deviceService.uploadTemplate(data, config).then((res) => {
            state.EmployeeErrors = []
            let resData = res.data.templateErrorMessage
            if (resData.length != 0) {
                notifyError(MESSAGES.RESOLVE_ERRORS)
                 commit("employeeError", resData)
            }
            else {
                notify(MESSAGES.TEMPLATE_UPLOAD_SUCCESS);
                res.data.bulkDevicesResponses.result.forEach((ele) => {
                    commit('addDevice', ele, { root: true });
                });
            }
        }).catch((err) => {
            notifyApiError(err)
        })
    },
    async DownloadTemp({ commit }) {
        await deviceService.downloadTemplate().then(({ data }) => {
            FileSaver(data, 'Device' + '.xlsx')
        }).catch(notifyApiError);
        commit('downloadData');
    },
}
const mutations = {
    get(state, devices) {
        state.devices = devices.data.result.records;
        state.totalCount=devices.data.result.totalRecordsCount;
        state.pageSize= devices.data.result.recordsCountPerPage
        // state.filteredDevices = devices;
    },
    getAudit(state,res){
        state.auditVals =res
       },
    getInitialData(state, data) {
        state.initialData = data;
    },
    setSensors(state, sensors) {
        state.sensors = sensors;
    },
    edit(state, actor) {
        state.editId = actor.deviceId
        state.newDevice = actor
        state.metadata = actor.metaData ? actor.metaData : {}
        router.push({ name: "deviceAddUpdate", params: { add: false } });
    },
    removeDevice(state,deviceId){
        console.log("devicers",deviceId);
        const index = state.devices.findIndex((d) => d.deviceId === deviceId);
        console.log(index);
        state.devices.splice(index, 1);
    },
    getFile(state, item) {
        if (item == 'Data not available') {
            state.driverFileList = []
        }
        else {
            state.driverFileList = item

        }

    },
    employeeError(state, data) {
    //    console.log("error",data)
        data.map(data => {
            if (data.error) {
                state.EmployeeErrors.push({ error: data.error, email: data.notAddedEmployee.emailID, empID: data.notAddedEmployee.employeeCode, empName: data.notAddedEmployee.name, })
            }
            else {
                state.EmployeeErrors.push({ error: data.errorMessage, cell: data.cell })
            }
        })
    },
    downloadData(){

    },
    exportedData(){

    },
    cancel(state) {
        state.metadata = {}
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}